import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

/**
 * This service is a browser service
 *
 * @example
 * BrowserService.isBrowser;
 *
 */
@Injectable()
export class BrowserService {
    /**
     * Get the isBrowser value.
     */
    isBrowser: boolean = isPlatformBrowser(this.platformId);

    constructor(@Inject(PLATFORM_ID) private platformId) {}
}
